import {doGET, shopRestBackendBaseUrl} from './mydummen.fetch.service';

const CUSTOMER_REST_BACKEND_BASE = `${shopRestBackendBaseUrl}/secured/app`;
const CONSIGNMENT_ENDPOINT = `${CUSTOMER_REST_BACKEND_BASE}/consignments`;

export const getConsignmentsForUser = async (): Promise<string[]> => {
	const response = await doGET(CONSIGNMENT_ENDPOINT);
	return await response.json();
};
